var m = require('mithril');
var prop = require('mithril/stream');
var R = require('ramda');
var _ = require('lodash');
var key = require('../libs/keybindings');
var masonry = require('../libs/masonry');
var loaders = require('../layout/components/loaders');
var auth = require('../auth/models/session');
var edit = require('../layout/components/edit');
var pathHeader = require('../layout/components/pathHeader');
var modalForm = require('../layout/components/modalForm');
var pointTd = require('../data/components/pointTd');
var columnForm = require('../data/components/columnModal');
var modal = require('../layout/components/modal');
var alarmsTable = require('../alarms/alarmsTable');
var megaMenu = require('./components/megaMenu');
var hasEquipmentModal = require('./components/hasEquipmentModal');
var editCustomEquipmentModal = require('../equipment/editCustomEquipmentModal');
var addSystemModal = require('./addSystemModal');
var mapElement = require('../maps/mapElement');
var equipmentDiagram = require('../equipment/components/equipmentDiagram');
var {LOCATION_CONFIGS, LOCATION_STYLES} = require('../maps/locationConfigs'); 
const AddCustomEquipmentModal = require('../equipment/addCustomEquipmentModal');
var rowActionDropdown = require('../components/rowActionDropdown');
var pageRequestState = require('../layout/components/pageRequestState');

var maxId = R.compose(R.propOr(0, 'id'), R.head, R.sort(R.descend(R.prop('id'))));

var systemDetail = {};

systemDetail.oninit = function (vnode) {
  var ctrl = this;
  document.title = 'nimrod | System';  
  ctrl.systemRecord = prop();
  ctrl.diagram = prop({});
  ctrl.redrawDiagram = prop(false);
  ctrl.parentLocation = prop();
  pageRequestState.initialize(ctrl);

  ctrl.init = function () {
    ctrl.systemRecordRid = m.route.param('id');
    var url = `/api/v1/system/${ctrl.systemRecordRid}`;
    return pageRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: url,
        method: 'GET',
      })
      .then(result => {
        if (!result || !Array.isArray(result.path)) {
          throw new Error('System response is missing its location path.');
        }
        if (!result.name && result.path[0]) {
          result.name = result.path[0]['@class'];
        }
        result.path.forEach((path) => {
          if (!path.name) {
            path.name = path['@class'];
          }
        });

        if (result.path[1]) {
          result.path[1].path = result.path.slice(1);
          ctrl.parentLocation(result.path[1]);
        }
        result.path.reverse();
        if (!result.data) {
          result.data = {};
        }
        ctrl.systemRecord(result);

        ctrl.equipmentRecordPortValues = ctrl.systemRecord().ports ? Object.values(ctrl.systemRecord().ports) : [];

        m.redraw();
      });
    }, { errorMessage: 'Unable to load System data:' });
  };

  ctrl.init();
  

  ctrl.initAndRedrawDiagram = async function () {
    await ctrl.init();
    ctrl.redrawDiagram(true);
    m.redraw();
  }
};

function findRightmostNode(diagram) {
  var rightmostNode = null;
  diagram.nodes.each(function (node) {
    if (!rightmostNode || node.position.x > rightmostNode.position.x) {
      rightmostNode = node;
    }
    if (node.position.x == rightmostNode.position.x && node.position.y < rightmostNode.position.y) {
      rightmostNode = node;
    }
  });
  return rightmostNode;
}


systemDetail.onupdate = function() {
  var ctrl = this;
  if (ctrl.systemRecordRid != m.route.param('id')) {
    ctrl.systemRecordRid = m.route.param('id');
    ctrl.diagram(undefined);
    ctrl.init();
  };
}

systemDetail.view = function () {
  var ctrl = this;
  var stateView = pageRequestState.view(ctrl);
  if (stateView) return stateView;
  if (!ctrl.systemRecord()) {
    return m('div')
  }
  return m('div.mh3.mv3', [
    m(pathHeader, {
      ancestors: ctrl.systemRecord().path, 
      record: ctrl.systemRecord(),
      class: '.flex.justify-between.display',
    },[
      edit.vm.editing() && auth.user().isSuperuser ?
        m(rowActionDropdown, {
          items: [
            {
              label: 'Edit System',
              icon: 'ion-android-exit',
              onclick: addSystemModal.editDialogue.bind(addSystemModal, ctrl.systemRecord(), ctrl.systemRecord().path[1], { submitCallback: ctrl.initAndRedrawDiagram })
            },
            {
              label: 'Edit Permissions',
              icon: 'ion-android-exit',
              onclick: m.route.set.bind(m, `/system/${ctrl.systemRecord()['@class']}/${ctrl.systemRecord()['@rid'].toString().slice(1)}/permissions`)
            }
          ]
        })
        :
        m('div')
    ]),
    m(megaMenu, {
      systemRecord: ctrl.systemRecord,
      submitCallback: ctrl.initAndRedrawDiagram,
      findRightmostNode: findRightmostNode,
      diagram: ctrl.diagram,
    }),
    m('div', {style: {height: '50vh', position: 'relative'}}, [
      (() => {
        if (ctrl?.systemRecord()?.useGeoPositioning) {
          return m(mapElement, {
            location: ctrl.parentLocation,
            locationConfig: LOCATION_CONFIGS['System'],
            systemRecord: ctrl.systemRecord,
            parentReinitialize: ctrl.init,
            diagram: ctrl.diagram,
            parentReinitializeAndRedraw: ctrl.initAndRedrawDiagram,
            redrawDiagram: ctrl.redrawDiagram,
            parentCtrl: ctrl,
            equipmentCoordinates: ctrl.systemRecord().out_hasEquipment,
            locationConfig: LOCATION_CONFIGS['System'],
          })
        } else {
          return m(equipmentDiagram, {
            location: ctrl.parentLocation,
            locationConfig: LOCATION_CONFIGS['System'],
            equipmentRecord: ctrl.systemRecord,
            parentReinitialize: ctrl.init,
            diagram: ctrl.diagram,
            parentReinitializeAndRedraw: ctrl.initAndRedrawDiagram,
            redrawDiagram: ctrl.redrawDiagram,
            parentCtrl: ctrl,
            equipmentCoordinates: ctrl.systemRecord().out_hasEquipment,
            useGeoPositioning: ctrl.systemRecord().useGeoPositioning,
            isSystem: true,
          })
        }
      })(),
    ]),
    m('div.mv3.bw1.pv1.tc.f3.bb', 'Equipment'),
    m('div.flex.w-100.flex-wrap', {onupdate: masonry}, [
      (ctrl.systemRecord().out_hasEquipment || []).map(hasEquipmentEdge => {
        let childEquipmentRecord = hasEquipmentEdge.in;
        return m('div.grid-item.w-100.w-50-ns.w-25-l.ph2.pv1',[
          m('div.ba.b--blue.bw1.pa2', [
            m('div.mb2', [
              edit.vm.editing() ?
                m(`div.mb2.blue${edit.vm.editing() ? '.pointer' : ''}`, {
                  onclick: edit.vm.editing() ? editCustomEquipmentModal.editDialogue.bind(editCustomEquipmentModal, {...childEquipmentRecord}, { submitCallback: ctrl.initAndRedrawDiagram, delete: true, deleteCallback: ctrl.initAndRedrawDiagram }) : ''
                }, `${childEquipmentRecord.name ? childEquipmentRecord.name : childEquipmentRecord['@class']}`)
              :
                m('a.mb2.blue.pointer', {
                  href: `/#!/equipment/${childEquipmentRecord['@class'].toLowerCase()}/${childEquipmentRecord['@rid'].slice(1)}`
                }, [
                  `${childEquipmentRecord.name ? childEquipmentRecord.name : childEquipmentRecord['@class']}`
                ])
            ]),
            (childEquipmentRecord.out_Contains || []).map((containsEdge, idx) => {
              let dataset = containsEdge.in;
              return m(`div.mb2${childEquipmentRecord.out_Contains && childEquipmentRecord.out_Contains.length ==  idx + 1 ? '' : '.bb.b--blue'}`, [
                dataset.name == 'Default' ? '' : m('div.b1', dataset.name),
                m('table.w-100', {style: {tableLayout: 'fixed'}}, [
                  (dataset.columns || []).map(function (column, jdx) {
                    let findedColumn;        
                    (dataset.out_Column || []).forEach(columnEdgeRecord => {
                      if (!findedColumn && columnEdgeRecord.name == column.name) findedColumn = columnEdgeRecord;
                    })
                    return m('tr', [
                      m(`td.f4.man.tl.moon-gray.w-50${dataset.columns && dataset.columns.length == jdx + 1 ? '' : '.bb'}`, [
                        m(`div${edit.vm.editing() ? '.blue.pointer' : ''}`, {
                          onclick: edit.vm.editing() ? editColumn.bind(null, column, jdx, dataset, ctrl) : ''
                        }, column.name)
                      ]),
                      findedColumn ? 
                        m(pointTd, {columnRecord: findedColumn, textAlign: 'center'}) 
                      :
                        edit.vm.editing() ?
                          m(`td.tc${dataset.columns && dataset.columns.length == jdx + 1 ? '' : '.bb'}`, {
                            onclick: columnForm.editDialogue.bind(columnForm, {out: dataset['@rid'], index: column.id}, {columnName: column.name, delete: true, submitCallback: ctrl.init})
                          }, [
                            m('i.ion-plus.blue')
                          ]) 
                        : 
                          m(`td.tc${dataset.columns && dataset.columns.length == jdx + 1 ? '' : '.bb'}`)
                    ])
                  }),
                  dataset.definedByParentEquipmentClass && dataset.name != 'Default' ? 
                    ''
                  : 
                    edit.vm.editing() ?
                      m('tr', [
                        m('td.bb.bl-0.tc', [
                          m('i.icon.ion-plus.blue', {onclick: addColumn.bind(null, dataset, ctrl)})
                          
                        ])
                      ])
                    :
                      ''
                ])
              ])
            })
          ])
        ])
      })
    ]),
    m('div.flex', [
      edit.vm.editing() ?
        [
          m('div.w-100.w-50-ns.w-50-l.ph2.pv1',[
            m('div.ba.b--blue.b--dashed.bw1.pa2', {
              onclick: hasEquipmentModal.editDialogue.bind(hasEquipmentModal, {parentSystem: ctrl.systemRecord()}, { submitCallback: ctrl.initAndRedrawDiagram })
            }, [
              m('div.flex.justify-center.blue', [
                m('i.ion-plus.mr2'),
                m('div', 'Add Equipment to System')
              ])
            ])
          ]),
          m('div.w-100.w-50-ns.w-50-l.ph2.pv1',[
            m('div.ba.b--blue.b--dashed.bw1.pa2', {
              onclick: AddCustomEquipmentModal.editDialogue.bind(AddCustomEquipmentModal, undefined, ctrl.systemRecord().path[1], undefined, { submitCallback: ctrl.initAndRedrawDiagram,  addToSystem: ctrl.systemRecord() })
            }, [
              m('div.flex.justify-center.blue', [
                m('i.ion-plus.mr2'),
                m('div', 'Create Equipment and Add to System')
              ])
            ])
          ])
        ]
        
      : ''
    ]),
    m('div.mv3.bw1.pv1.tc.f3.bb', 'Sub-systems'),
    m('div.flex.w-100.flex-wrap', {onupdate: masonry}, [
      (ctrl.systemRecord().out_hasSystem || []).map(hasSystemEdge => {
        let childSystemRecord = hasSystemEdge.in;
        return m('div.grid-item.w-100.w-50-ns.w-25-l.ph2.pv1',[
          m('div.ba.b--blue.bw1.pa2', [
            m('div.mb2', [
              m('a.mb2.blue.pointer', {
                href: `/#!/system/${childSystemRecord['@rid'].slice(1)}`
              }, [
                `${childSystemRecord.name ? childSystemRecord.name : childSystemRecord['@class']}`
              ])
            ]),
          ])
        ])
      })
    ]),
    m('div.flex', [
      edit.vm.editing() ?
        [
          m('div.w-100.w-50-ns.w-50-l.ph2.pv1',[
            m('div.ba.b--blue.b--dashed.bw1.pa2', {
              onclick: addSystemModal.editDialogue.bind(addSystemModal, undefined, ctrl.systemRecord(), { submitCallback: ctrl.initAndRedrawDiagram })
            }, [
              m('div.flex.justify-center.blue', [
                m('i.ion-plus.mr2'),
                m('div', 'Add Sub-system to System')
              ])
            ])
          ])
        ]
        
      : ''
    ]),
    m(alarmsTable, {
      equipmentAllRids: [{...ctrl.systemRecord()}],
      dashboardsAllRids: [],
      selectedView: prop(),
      location: prop({...ctrl.systemRecord()}),
    })
    
  ])
};

function addColumn(datasetRecord, ctrl) {
  var currentColumns = cloneColumns(datasetRecord.columns);
  var newId = currentColumns.length === 0 ? 0 : maxId(currentColumns) + 1;
  var saveError = prop('');
  var newColumn = {
    name: '',
    id: newId
  };

  modal.vm.title('New Column');
  modal.vm.body = function () {
    return formViewAdd(newColumn, saveError);
  };

  var submit = function() {
    return persistDatasetColumns(datasetRecord, currentColumns.concat([newColumn]), ctrl, saveError);
  };

  modal.vm.buttons([
    {
      label: "Submit",
      class: "dib ",
      func: submit
    }
  ])

  key.setScope('modal');
  key('enter', 'modal', enterSubmitHandler(submit));

  modal.vm.open();
};

function cloneColumns(columns) {
  return (Array.isArray(columns) ? columns : []).map(function (column) {
    return Object.assign({}, column);
  });
}

function enterSubmitHandler(submit) {
  return function () {
    // keymaster ignores returned promises. Catch here so pressing Enter has
    // the same safe failure behavior as clicking the modal button.
    return submit().catch(function () { return null; });
  };
}

function persistDatasetColumns(datasetRecord, nextColumns, ctrl, saveError) {
  saveError('');
  return loaders.requestWithLoader({
    loader: 'background',
    url: `/api/v1/dataset/${datasetRecord['@rid'].slice(1)}`,
    method: 'PUT',
    body: {columns: nextColumns}
  })
  .then(function () {
    // Do not change the live view until the API has accepted the change.
    datasetRecord.columns = nextColumns;
    key.unbind('enter');
    modal.vm.close();
    return ctrl.initAndRedrawDiagram();
  })
  .catch(function (error) {
    console.error('Unable to save dataset columns:', error);
    saveError('Unable to save dataset columns. Please try again.');
    m.redraw();
    throw error;
  });
}

function formViewAdd (newColumn, saveError) {
  return m('div', [
    m('form', {role: 'form'}, [
      m('div', {class: 'form-group'}, [
        m('div', 'Name'),
        m('input.form-control', {
          type: 'text',
          autocomplete: 'off',
          oninput: function(ev) { newColumn.name = ev.target.value; },
          value: newColumn.name,
        })
      ])
    ]),
    saveError && saveError() ?
      m('div.red.mt3', { role: 'alert' }, saveError())
      :
      ''
  ]);
}

function editColumn(column, colIdx, datasetRecord, ctrl) {
  var currentColumns = cloneColumns(datasetRecord.columns);
  var draftColumn = Object.assign({}, column);
  var saveError = prop('');
  modal.vm.title('Edit Column');
  modal.vm.body = function () {
    return formViewAdd(draftColumn, saveError);
  };

  var submit = function() {
    var nextColumns = cloneColumns(currentColumns);
    nextColumns[colIdx] = draftColumn;
    return persistDatasetColumns(datasetRecord, nextColumns, ctrl, saveError);
  };
  var remove = function () {
    var nextColumns = cloneColumns(currentColumns);
    nextColumns.splice(colIdx, 1);
    return persistDatasetColumns(datasetRecord, nextColumns, ctrl, saveError);
  };
  modal.vm.buttons([
    {
      label: "Delete",
      class: "dib mr2 red ",
      func: remove
    },
    {
      label: "Submit",
      class: "dib ",
      func: submit
    } 
  ])

  key.setScope('modal');
  key('enter', 'modal', enterSubmitHandler(submit));

  modal.vm.open();
}

systemDetail._private = {
  addColumn: addColumn,
  editColumn: editColumn,
  cloneColumns: cloneColumns,
  enterSubmitHandler: enterSubmitHandler
};

module.exports = systemDetail;
